import React from 'react';
import { Alert } from '../types/alert';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface AlertContextProps {
  alerts: Map<string, Alert>;
  setAlerts: (alerts: Map<string, Alert>) => void;
  alertsLoading: boolean;
}

const defaultContext: AlertContextProps = {
  alerts: new Map(),
  setAlerts: () => {},
  alertsLoading: false,
};

export const AlertContext = React.createContext<AlertContextProps>(defaultContext);

interface AlertState {
  items: Record<string, any>[];
  loading: boolean;
}

export const alertSlice = createSlice({
  name: 'alert',
  initialState: { items: [], loading: true } as AlertState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<Alert[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    add: (state, action: PayloadAction<Alert[]>) => {
      const map = new Map(
        [...state.items, ...action.payload.map(p => instanceToPlain(p))].map(alert => [alert.id, alert]),
      );
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
